(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lz-collection-banners"]) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const notice = event.target.closest('.tj-banner-editor-target');
  if (notice) { notice.hidden = false; notice.scrollIntoView({ block: 'center' }); }
});
document.addEventListener('shopify:block:deselect', (event) => {
  const notice = event.target.closest('.tj-banner-editor-target');
  if (notice) notice.hidden = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-media-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('member-product-epub-reader')) return;
  let dependencies;
  let fullscreenOwner = null;
  const limitTime = (promise, ms, message) => {
    let timer;
    return Promise.race([promise,new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    })]).finally(() => clearTimeout(timer));
  };
  function script(src) {
    return new Promise((resolve,reject) => {
      const element = document.createElement('script');
      const timer = setTimeout(() => {
        element.remove(); reject(new Error('閱讀器元件載入逾時，請重新整理後再試。'));
      },25000);
      element.src = src; element.async = true;
      element.onload = () => {clearTimeout(timer);resolve();};
      element.onerror = () => {clearTimeout(timer);element.remove();reject(new Error('無法載入閱讀器元件，請檢查網路。'));};
      document.head.appendChild(element);
    });
  }
  function loadDependencies() {
    if (!dependencies) dependencies = (async () => {
      if (!window.JSZip) await script('https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js');
      if (!window.ePub) await script('https://cdn.jsdelivr.net/npm/epubjs@0.3.93/dist/epub.min.js');
      if (!window.ePub || !window.JSZip) throw new Error('閱讀器元件未正常啟動。');
    })().catch(error => {dependencies = null;throw error;});
    return dependencies;
  }
  class EpubReader extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      this.events = new AbortController();
      this.shell = this.querySelector('.er-shell');
      this.ui = {};
      ['intro','start','status','workspace','controls','toc','font-controls','font-down','font-up','font-value','reset','fullscreen','viewport','left','right','center','prev','next','location','top','bottom','fs-hint','full-hint','theme'].forEach(key => {
        this.ui[key] = this.shell.querySelector('[data-' + key + ']');
      });
      this.remember = this.dataset.remember === 'true';
      this.font = Number(this.dataset.font) || 18;
      this.ready = false;
      const on = (el,name,fn) => el.addEventListener(name,fn,{signal:this.events.signal});
      on(this.ui.start,'click',() => this.start());
      on(this.ui.prev,'click',() => this.move('prev'));
      on(this.ui.next,'click',() => this.move('next'));
      on(this.ui.left,'click',() => this.move(this.rtl ? 'next' : 'prev'));
      on(this.ui.right,'click',() => this.move(this.rtl ? 'prev' : 'next'));
      on(this.ui.toc,'change',() => {if(this.ui.toc.value) this.navigate(() => this.rendition.display(this.ui.toc.value));});
      on(this.ui['font-down'],'click',() => this.changeFont(-2));
      on(this.ui['font-up'],'click',() => this.changeFont(2));
      on(this.ui.reset,'click',() => this.resetFont());
      on(this.ui.theme,'change',() => {this.applyTheme();this.savePosition();});
      on(this.ui.fullscreen,'click',() => this.toggleFullscreen());
      on(this.ui.center,'click',() => this.setMenu(!this.menuOpen));
      on(this.shell,'keydown',event => this.key(event));
      on(document,'fullscreenchange',() => this.fullscreenChanged());
      on(document,'webkitfullscreenchange',() => this.fullscreenChanged());
      this.bookIndex = '1';
      this.shell.querySelectorAll('[data-book-source]').forEach(button => {
        let name = '';
        try {
          name = new URL(button.dataset.bookSource, location.href).pathname.split('/').pop();
          try {name = decodeURIComponent(name);} catch (_) {}
        } catch (_) {}
        name = name.replace(/\.[^.]+$/, '') || '未命名電子書';
        button.textContent = name;
        button.title = name;
      });
      on(this.shell,'click',event => {
        const button = event.target.closest('[data-book-source]');
        if (button) this.selectBook(button);
      });
      this.updateFont();
    }
    async selectBook(button) {
      if (this.navigating || this.switching || this.entering) return;
      const source = button.dataset.bookSource;
      if (source === this.dataset.source && (this.ready || this.loading)) return;
      this.switching = true;
      try {
        this.savePosition();
        if (this.full) await this.exitFullscreen();
        if (this.full || !this.isConnected) return;
        this.token = null;
        if (this.request) this.request.abort();
        this.destroyBook();
        this.storageKey = null; this.size = null;
        this.loading = false; this.navigating = false;
        this.dataset.source = source;
        this.bookIndex = button.dataset.bookIndex;
        this.ui.theme.value = 'light';
        this.ui.workspace.hidden = false;
        this.ui.intro.hidden = false;
        this.ui.start.disabled = false;
        this.ui.start.textContent = '開始閱讀';
        this.ui.controls.disabled = true;
        this.ui.toc.replaceChildren(new Option('載入目錄',''));
        this.ui.location.textContent = '位於章節索引 —';
        this.updateButtons();
        this.shell.querySelectorAll('[data-book-source]').forEach(el => {
          el.setAttribute('aria-pressed',String(el.dataset.bookIndex === this.bookIndex));
        });
        this.start();
      } finally {this.switching = false;}
    }
    message(text,error=false) {
      this.ui.status.textContent = text;
      this.ui.status.dataset.error = String(error);
    }
    async start() {
      if (this.loading || this.ready) return;
      this.loading = true; this.ui.start.disabled = true;
      this.shell.classList.add('er-loading');
      this.ui.start.textContent = '正在載入…';
      this.shell.setAttribute('aria-busy','true');
      const token = {}; this.token = token;
      const alive = () => this.isConnected && this.token === token;
      let timer;
      this.message('正在載入電子書，較大的檔案需要稍候。');
      try {
        const url = new URL(this.dataset.source,location.href);
        if (!['https:','http:'].includes(url.protocol) || (location.protocol === 'https:' && url.protocol !== 'https:')) throw new Error('請填入有效的 HTTPS EPUB 檔案網址。');
        await loadDependencies(); if (!alive()) return;
        this.request = new AbortController();
        const request = this.request;
        timer = setTimeout(() => request.abort(),60000);
        const response = await fetch(url.href,{signal:request.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error([401,403].includes(response.status) ? '沒有讀取權限，請確認登入狀態。' : '檔案載入失敗，HTTP ' + response.status);
        const buffer = await response.arrayBuffer(); clearTimeout(timer);
        if (!alive()) return;
        const signature = new Uint8Array(buffer,0,Math.min(2,buffer.byteLength));
        if (signature[0] !== 0x50 || signature[1] !== 0x4b) throw new Error('網址未回傳 EPUB 檔案，請勿使用商品頁或下載頁網址。');
        const book = window.ePub(); this.book = book;
        await limitTime(book.open(buffer,'binary'),30000,'電子書解析逾時，請確認檔案格式。');
        if (!alive()) return;
        this.storageKey = 'member_epub_v4:' + this.dataset.customer + ':' + this.dataset.product + ':' + this.dataset.source;
        const metadata = book.packaging.metadata;
        this.rtl = metadata.direction === 'rtl';
        this.fixed = metadata.layout === 'pre-paginated';
        this.ui['font-controls'].hidden = false;
        this.ui.workspace.hidden = false;
        // First-version typography controls; always show a single page.
        this.rendition = book.renderTo(this.ui.viewport,{
          width:'100%',height:'100%',flow:'paginated',spread:'none',
          allowScriptedContent:false,allowPopups:false
        });
        this.rendition.on('relocated',value => {if(alive()) this.relocated(value);});
        this.rendition.on('keydown',event => this.key(event));
        this.rendition.hooks.content.register(function (contents) {
        contents.document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, true);
        });
        this.restoreSettings();
        this.applyTheme();
        this.rendition.themes.fontSize(this.font + 'px');
        this.updateFont();
        const navigation = await limitTime(book.loaded.navigation,15000,'無法讀取目錄。');
        if (!alive()) return;
        this.buildToc(navigation.toc || []);
        const saved = this.readPosition();
        try {
          await limitTime(this.rendition.display(saved || undefined),20000,'無法顯示書籍。');
        } catch(error) {
          if (!saved || !alive()) throw error;
          await limitTime(this.rendition.display(),20000,'無法顯示書籍。');
        }
        if (!alive()) return;
        this.shell.classList.add('er-expanded');
        this.ready = true; this.ui.controls.disabled = false; this.ui.intro.hidden = true;
        this.message('單頁閱讀｜點左右兩側翻頁；全螢幕時點中央開啟選單。');
        this.updateButtons();
        this.size = [this.ui.viewport.clientWidth,this.ui.viewport.clientHeight];
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleResize());
          this.observer.observe(this.ui.viewport);
        }
      } catch(error) {
        if (!alive()) return;
        this.destroyBook(); this.ui.workspace.hidden = false; this.ui.intro.hidden = false;
        this.ui.start.textContent = '重新載入';
        this.message(error.name === 'AbortError' ? '下載逾時，請檢查網路後再試。' : error instanceof TypeError ? '無法讀取 EPUB，請檢查網址、網路與跨網域讀取設定。' : error.message,true);
      } finally {
        clearTimeout(timer);
        if (this.token === token) {this.loading = false;this.ui.start.disabled = false;this.shell.classList.remove('er-loading');this.shell.setAttribute('aria-busy','false');}
      }
    }
    buildToc(items) {
      this.ui.toc.replaceChildren();
      this.ui.toc.add(new Option(items.length ? '選擇章節' : '本書未提供目錄',''));
      const append = (entries,depth) => entries.forEach(item => {
        if (item.href) this.ui.toc.add(new Option('　'.repeat(Math.min(depth,5)) + String(item.label || '未命名章節').trim(),item.href));
        if (item.subitems) append(item.subitems,depth+1);
      });
      append(items,0); this.ui.toc.disabled = this.ui.toc.options.length < 2;
    }
    relocated(value) {
      if (!this.isConnected || !this.book) return;
      this.position = value;
      if (value.start) {
        this.ui.location.textContent = '位於章節索引 ' + (Number(value.start.index)+1) + ' / ' + Math.max(1,this.book.spine.spineItems.length - 1);
        const href = String(value.start.href || '').split('#')[0];
        const match = Array.from(this.ui.toc.options).find(option => option.value && option.value.split('#')[0] === href);
        this.ui.toc.value = match ? match.value : '';
        this.savePosition();
      }
      this.updateButtons();
    }
    updateButtons() {
      const busy = !this.ready || this.navigating;
      const prev = busy || Boolean(this.position && this.position.atStart);
      const next = busy || Boolean(this.position && this.position.atEnd);
      this.ui.prev.disabled = prev; this.ui.next.disabled = next;
      this.ui.left.disabled = this.rtl ? next : prev;
      this.ui.right.disabled = this.rtl ? prev : next;
      this.ui.left.setAttribute('aria-label',this.rtl ? '下一頁' : '上一頁');
      this.ui.right.setAttribute('aria-label',this.rtl ? '上一頁' : '下一頁');
    }
    async navigate(action) {
      if (!this.ready || this.navigating) return;
      this.navigating = true; this.ui.controls.disabled = true;
      this.ui.viewport.setAttribute('aria-busy','true'); this.updateButtons();
      try {await action();}
      catch(_) {if(this.isConnected) this.message('無法切換指定位置，請選擇其他章節或重新整理。',true);}
      finally {
        this.navigating = false;
        if(this.isConnected) {
          this.ui.controls.disabled = false; this.ui.viewport.setAttribute('aria-busy','false'); this.updateButtons();
        }
      }
    }
    move(direction) {
      if(!this.rendition) return;
      if(this.position && (direction === 'prev' ? this.position.atStart : this.position.atEnd)) return;
      this.navigate(() => this.rendition[direction]());
    }
    key(event) {
      if(event.key === 'Escape' && this.full) {
        event.preventDefault(); this.exitFullscreen(); return;
      }
      if (event.key === 'Tab' && this.full) {
        // Keep keyboard navigation in the full-screen reader, including CSS fallback.
        const items = Array.from(this.shell.querySelectorAll('button,select,[tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const index = items.indexOf(document.activeElement);
        if(items.length && (index === -1 || (event.shiftKey ? index === 0 : index === items.length-1))) {
          event.preventDefault(); items[event.shiftKey ? items.length-1 : 0].focus();
        }
        return;
      }
      if(event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      if(event.target.closest && event.target.closest('input,textarea,select,button,a,[contenteditable]')) return;
      if(!this.ready || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move((this.rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight') ? 'next' : 'prev');
    }
    changeFont(delta) {
      if(!this.ready || this.navigating) return;
      this.font = Math.max(14,Math.min(32,(this.font || Number(this.dataset.font) || 18)+delta));
      this.rendition.themes.fontSize(this.font + 'px'); this.updateFont(); this.savePosition();
    }
    resetFont() {
      if(!this.ready || this.navigating) return;
      this.font = Number(this.dataset.font) || 18;
      this.rendition.themes.fontSize(this.font + 'px');
      this.updateFont(); this.savePosition();
    }
    updateFont() {
      this.shell.style.setProperty('--er-hint-font',this.font + 'px');
      this.ui['font-value'].textContent = this.font + 'px';
      this.ui['font-down'].disabled = this.font <= 14;
      this.ui['font-up'].disabled = this.font >= 32;
      this.ui.reset.disabled = this.font === (Number(this.dataset.font) || 18);
    }
    applyTheme() {
      if(!this.rendition) return;
      const palettes = {
        light:{background:'#ffffff',text:'#202934',link:'#1659a5'},
        sepia:{background:'#f6efdf',text:'#433a2e',link:'#72501e'},
        dark:{background:'#20252b',text:'#e3e8ee',link:'#96c8ff'}
      };
      const palette = palettes[this.ui.theme.value] || palettes.light;
      this.ui.viewport.style.backgroundColor = palette.background;
      this.ui.viewport.parentElement.style.backgroundColor = palette.background;
      this.shell.style.backgroundColor = palette.background;
      this.rendition.themes.default({
        'html':{'background':palette.background+' !important'},
        'body':{'background':palette.background+' !important','color':palette.text+' !important','line-height':'1.8 !important','overflow-wrap':'break-word'},
        'p, div, span, li, h1, h2, h3, h4, h5, h6, blockquote':{'color':palette.text+' !important'},
        'a':{'color':palette.link+' !important'},
        'img, svg, video':{'max-width':'100% !important','max-height':'100% !important','object-fit':'contain'}
      });
    }
    restoreSettings() {
      if(!this.remember) return;
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if(saved && Number.isFinite(saved.font)) this.font = Math.max(14,Math.min(32,saved.font));
        if(saved && ['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
      } catch(_) {}
    }
    showFullscreenHint() {
      clearTimeout(this.hintTimer);
      this.shell.classList.add('er-show-zones');
      this.ui['full-hint'].hidden = false;
      this.hintTimer = setTimeout(() => {
        this.ui['full-hint'].hidden = true;
        this.shell.classList.remove('er-show-zones');
      },3000);
    }
    async toggleFullscreen() {
      if(this.full) {await this.exitFullscreen();return;}
      if(!this.ready || this.entering || fullscreenOwner) return;
      this.entering = true; fullscreenOwner = this;
      // Capture the actual book viewport BEFORE portaling or hiding scrollbars.
      this.shell.style.setProperty('--er-reading-width',this.ui.viewport.clientWidth + 'px');
      this.returnFocus = document.activeElement;
      this.placeholder = document.createComment('EPUB fullscreen return position');
      this.shell.before(this.placeholder);
      // Portal only the shell: custom element stays mounted and keeps book state.
      document.body.appendChild(this.shell);
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.full = true; this.native = false;
      this.shell.classList.add('er-full');
      this.ui.center.hidden = false; this.ui['fs-hint'].hidden = false;
      this.ui.fullscreen.textContent = '退出全螢幕';
      this.setMenu(false); this.ui.center.focus({preventScroll:true});
      const request = this.shell.requestFullscreen || this.shell.webkitRequestFullscreen;
      try {
        if(request) {
          await request.call(this.shell);
          this.native = (document.fullscreenElement || document.webkitFullscreenElement) === this.shell;
        }
      } catch(_) {
        // iPhone / restricted iframe: CSS viewport fullscreen is the fallback.
      } finally {
        this.entering = false;
        if(!this.isConnected) this.restoreFullscreen();
        else if(this.full) {this.scheduleResize();this.showFullscreenHint();}
      }
    }
    setMenu(open) {
      this.menuOpen = Boolean(open);
      this.shell.classList.toggle('er-menu-open',this.menuOpen);
      this.ui.center.setAttribute('aria-expanded',String(this.menuOpen));
      this.ui.center.setAttribute('aria-label',this.menuOpen ? '收起閱讀選單' : '顯示閱讀選單');
      for(const key of ['top','bottom']) {
        this.ui[key].inert = Boolean(this.full && !this.menuOpen);
      }
    }
    fullscreenChanged() {
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {this.native = true;return;}
      if(this.full && this.native) this.restoreFullscreen();
    }
    async exitFullscreen() {
      if(!this.full) return;
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        try {if(exit) await exit.call(document);} catch(_) {return;}
      }
      this.restoreFullscreen();
    }
    restoreFullscreen() {
      if(!this.full) return;
      clearTimeout(this.hintTimer); this.ui['full-hint'].hidden = true;
      this.full = false; this.native = false;
      this.shell.style.removeProperty('--er-reading-width');
      this.shell.classList.remove('er-full','er-menu-open','er-show-zones');
      this.ui.center.hidden = true; this.ui['fs-hint'].hidden = true;
      this.ui.fullscreen.textContent = '全螢幕';
      this.setMenu(false);
      if(this.placeholder && this.placeholder.parentNode) this.placeholder.replaceWith(this.shell);
      else this.appendChild(this.shell);
      document.body.style.overflow = this.oldOverflow || '';
      if(fullscreenOwner === this) fullscreenOwner = null;
      if(this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({preventScroll:true});
      this.scheduleResize();
    }
    scheduleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if(!this.ready || !this.rendition || !this.isConnected) return;
        const width = this.ui.viewport.clientWidth, height = this.ui.viewport.clientHeight;
        if(width < 1 || height < 1 || (this.size && this.size[0] === width && this.size[1] === height)) return;
        this.size = [width,height]; this.rendition.resize(width,height);
      },120);
    }
    readPosition() {
      if(!this.remember) return null;
      try {const value = JSON.parse(localStorage.getItem(this.storageKey));return value && typeof value.cfi === 'string' ? value.cfi : null;} catch(_) {return null;}
    }
    savePosition() {
      if(!this.remember || !this.storageKey || !this.position || !this.position.start) return;
      try {localStorage.setItem(this.storageKey,JSON.stringify({cfi:this.position.start.cfi,font:this.font,theme:this.ui.theme.value}));} catch(_) {}
    }
    destroyBook() {
      clearTimeout(this.hintTimer);
      this.ready = false; this.position = null; this.font = Number(this.dataset.font) || 18;
      if(this.observer) this.observer.disconnect();
      clearTimeout(this.resizeTimer);
      try {if(this.rendition) this.rendition.destroy();} catch(_) {}
      try {if(this.book) this.book.destroy();} catch(_) {}
      this.rendition = null; this.book = null;
      if(this.ui) {this.ui.viewport.replaceChildren();this.updateFont();}
    }
    disconnectedCallback() {
      this.savePosition(); this.token = null;
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      if(this.request) this.request.abort();
      if(this.ui) {this.restoreFullscreen(); this.destroyBook();}
      this.loading = false; this.navigating = false; this.initialized = false;
    }
  }
  customElements.define('member-product-epub-reader',EpubReader);
})();

(() => {
  if(customElements.get('member-product-bunny-playlist')) return;
  class BunnyPlaylist extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if(!this.isConnected) return;
      const frame = this.querySelector('[data-bunny-frame]');
      const status = this.querySelector('[data-media-status]');
      const buttons = [...this.querySelectorAll('[data-media-path]')];
      const valid = buttons.filter(button => {
        const path = button.dataset.mediaPath.trim();
        const ok = /^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden = !ok;
        if(ok) button.dataset.mediaPath = path;
        return ok;
      });
      if(valid.length !== buttons.length) {
        status.hidden = false;
        status.textContent = '部分影音資料格式不正確，請聯絡網站管理員。';
      }
      frame.hidden = !valid.length;
      const nav = this.querySelector('.mm-playlist');
      nav.hidden = valid.length === 0;
      this.querySelector('.mm-media-layout').classList.toggle('mm-has-list',valid.length > 0);
      const select = button => {
        if(button.getAttribute('aria-pressed') === 'true') return;
        frame.src = 'https://player.mediadelivery.net/embed/' + button.dataset.mediaPath + '?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
        frame.title = '影音播放器：' + button.textContent.trim();
        valid.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      };
      this.events = new AbortController();
      valid.forEach((button,index) => {
        button.textContent = '第 ' + (index + 1) + ' 集';
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',() => select(button),{signal:this.events.signal});
      });
      const syncPlaylistHeight = () => {
        const height = frame.getBoundingClientRect().height;
        if (height > 0) this.style.setProperty('--mm-video-height', height + 'px');
      };
      if (typeof ResizeObserver !== 'undefined') {
        this.sizeObserver = new ResizeObserver(syncPlaylistHeight);
        this.sizeObserver.observe(frame);
      }
      window.addEventListener('resize', syncPlaylistHeight, {signal:this.events.signal});
      frame.addEventListener('load', syncPlaylistHeight, {signal:this.events.signal});
      syncPlaylistHeight();
      if(valid.length) select(valid[0]);
    }
    disconnectedCallback() {
      if(this.sizeObserver) this.sizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      this.initialized = false;
    }
  }
  customElements.define('member-product-bunny-playlist',BunnyPlaylist);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-or-bought-limit"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('member-product-epub-reader')) return;
  let pdfDependencies;
  let pdfBase = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/';
  function loadPdfDependencies(text) {
    if (!pdfDependencies) pdfDependencies = (async () => {
      const sources = [
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/',
        'https://unpkg.com/pdfjs-dist@4.10.38/'
      ];
      let lastError;
      for (const base of sources) {
        try {
          const lib = await limitTime(import(base + 'legacy/build/pdf.min.mjs'),15000,text('pdf_timeout'));
          lib.GlobalWorkerOptions.workerSrc = base + 'legacy/build/pdf.worker.min.mjs';
          pdfBase = base;
          return lib;
        } catch (error) {lastError = error;}
      }
      throw lastError;
    })().catch(error => {pdfDependencies = null; throw error;});
    return pdfDependencies;
  }
  let dependencies;
  let fullscreenOwner = null;
  const limitTime = (promise, ms, message) => {
    let timer;
    return Promise.race([promise,new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    })]).finally(() => clearTimeout(timer));
  };
  function script(src, text) {
    return new Promise((resolve,reject) => {
      const element = document.createElement('script');
      const timer = setTimeout(() => {
        element.remove(); reject(new Error(text('ui_09')));
      },25000);
      element.src = src; element.async = true;
      element.onload = () => {clearTimeout(timer);resolve();};
      element.onerror = () => {clearTimeout(timer);element.remove();reject(new Error(text('ui_10')));};
      document.head.appendChild(element);
    });
  }
  function loadDependencies(text) {
    if (!dependencies) dependencies = (async () => {
      if (!window.JSZip) await script('https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js', text);
      if (!window.ePub) await script('https://cdn.jsdelivr.net/npm/epubjs@0.3.93/dist/epub.min.js', text);
      if (!window.ePub || !window.JSZip) throw new Error(text('ui_11'));
    })().catch(error => {dependencies = null;throw error;});
    return dependencies;
  }
  class EpubReader extends HTMLElement {
    text(key, values = {}) {
      if (!this.uiStrings) {
        try { this.uiStrings = JSON.parse(this.dataset.i18n || '{}'); }
        catch (_) { this.uiStrings = {}; }
      }
      const value = String(this.uiStrings[key] ?? '');
      return value.replace(/\[(\w+)\]/g, (match, name) =>
        Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      this.events = new AbortController();
      this.shell = this.querySelector('.er-shell');
      this.ui = {};
      ['intro','start','status','workspace','controls','toc','font-controls','font-down','font-up','font-value','reset','fullscreen','viewport','left','right','center','prev','next','location','top','bottom','fs-hint','full-hint','theme'].forEach(key => {
        this.ui[key] = this.shell.querySelector('[data-' + key + ']');
      });
      this.remember = this.dataset.remember === 'true';
      this.font = Number(this.dataset.font) || 18;
      this.ready = false;
      const on = (el,name,fn) => el.addEventListener(name,fn,{signal:this.events.signal});
      on(this.ui.start,'click',() => this.start());
      on(this.ui.prev,'click',() => this.move('prev'));
      on(this.ui.next,'click',() => this.move('next'));
      on(this.ui.left,'click',() => this.move(this.rtl ? 'next' : 'prev'));
      on(this.ui.right,'click',() => this.move(this.rtl ? 'prev' : 'next'));
      on(this.ui.toc,'change',() => {if(this.ui.toc.value) this.navigate(() => this.rendition.display(this.ui.toc.value));});
      on(this.ui['font-down'],'click',() => this.changeFont(-2));
      on(this.ui['font-up'],'click',() => this.changeFont(2));
      on(this.ui.reset,'click',() => this.resetFont());
      on(this.ui.theme,'change',() => {this.applyTheme();this.savePosition();});
      on(this.ui.fullscreen,'click',() => this.toggleFullscreen());
      on(this.ui.center,'click',() => this.setMenu(!this.menuOpen));
      on(this.shell,'keydown',event => this.key(event));
      on(document,'fullscreenchange',() => this.fullscreenChanged());
      on(document,'webkitfullscreenchange',() => this.fullscreenChanged());
      this.bookIndex = '1';
      this.shell.querySelectorAll('[data-book-source]').forEach(button => {
        let name = '';
        try {
          name = new URL(button.dataset.bookSource, location.href).pathname.split('/').pop();
          try {name = decodeURIComponent(name);} catch (_) {}
        } catch (_) {}
        name = name.replace(/\.[^.]+$/, '') || this.text('ui_12');
        button.textContent = name;
        button.title = name;
      });
      on(this.shell,'click',event => {
        const button = event.target.closest('[data-book-source]');
        if (button) this.selectBook(button);
      });
      on(this.ui.viewport,'contextmenu',event => event.preventDefault());
      this.pdfTopToggle = document.createElement('button');
      this.pdfTopToggle.type = 'button'; this.pdfTopToggle.className = 'er-pdf-top-toggle';
      this.pdfTopToggle.textContent = this.text('pdf_show_top');
      this.pdfTopToggle.setAttribute('aria-expanded','false');
      this.ui.next.before(this.pdfTopToggle);
      on(this.pdfTopToggle,'click',() => this.setMenu(!this.menuOpen));
      this.pdfWidth = document.createElement('button');
      this.pdfWidth.type = 'button'; this.pdfWidth.hidden = true;
      this.pdfWidth.textContent = this.text('pdf_width');
      this.ui['font-controls'].appendChild(this.pdfWidth);
      on(this.pdfWidth,'click',() => this.fitPdf('width'));
      this.ui.viewport.tabIndex = 0;
      on(this.ui.viewport,'pointerdown',event => {
        if(!this.isPdf || !this.ready || event.pointerType !== 'mouse' || event.button !== 0) return;
        const box = this.ui.viewport;
        if(event.offsetX >= box.clientWidth || event.offsetY >= box.clientHeight) return;
        this.pdfDrag = {id:event.pointerId,x:event.clientX,y:event.clientY,left:box.scrollLeft,top:box.scrollTop};
        box.setPointerCapture(event.pointerId); box.classList.add('er-dragging');
        box.focus({preventScroll:true}); event.preventDefault();
      });
      on(this.ui.viewport,'pointermove',event => {
        if(!this.pdfDrag || this.pdfDrag.id !== event.pointerId) return;
        this.ui.viewport.scrollLeft = this.pdfDrag.left - event.clientX + this.pdfDrag.x;
        this.ui.viewport.scrollTop = this.pdfDrag.top - event.clientY + this.pdfDrag.y;
      });
      const releaseDrag = () => {this.pdfDrag=null;this.ui.viewport.classList.remove('er-dragging');};
      on(this.ui.viewport,'pointerup',releaseDrag);
      on(this.ui.viewport,'pointercancel',releaseDrag);
      on(this.ui.viewport,'lostpointercapture',releaseDrag);
      this.updateFont();
    }
    async selectBook(button) {
      if (this.navigating || this.switching || this.entering) return;
      const source = button.dataset.bookSource;
      if (source === this.dataset.source && (this.ready || this.loading)) return;
      this.switching = true;
      try {
        this.savePosition();
        if (this.full) await this.exitFullscreen();
        if (this.full || !this.isConnected) return;
        this.token = null;
        if (this.request) this.request.abort();
        this.destroyBook();
        this.storageKey = null; this.size = null;
        this.loading = false; this.navigating = false;
        this.dataset.source = source;
        this.bookIndex = button.dataset.bookIndex;
        this.ui.theme.value = 'light';
        this.ui.workspace.hidden = false;
        this.ui.intro.hidden = false;
        this.ui.start.disabled = false;
        this.ui.start.textContent = this.text('ui_13');
        this.ui.controls.disabled = true;
        this.ui.toc.replaceChildren(new Option(this.text('ui_14'),''));
        this.ui.location.textContent = this.text('ui_15');
        this.updateButtons();
        this.shell.querySelectorAll('[data-book-source]').forEach(el => {
          el.setAttribute('aria-pressed',String(el.dataset.bookIndex === this.bookIndex));
        });
        this.start();
      } finally {this.switching = false;}
    }
    message(text,error=false) {
      this.ui.status.textContent = text;
      this.ui.status.dataset.error = String(error);
    }
    async start() {
      if (this.loading || this.ready) return;
      this.loading = true; this.ui.start.disabled = true;
      this.shell.classList.add('er-loading');
      this.ui.start.textContent = this.text('ui_16');
      this.shell.setAttribute('aria-busy','true');
      const token = {}; this.token = token;
      const alive = () => this.isConnected && this.token === token;
      let timer;
      this.loadStage = 'FILE-URL';
      this.message(this.text('ui_17'));
      try {
        const url = new URL(this.dataset.source,location.href);
        if (!['https:','http:'].includes(url.protocol) || (location.protocol === 'https:' && url.protocol !== 'https:')) throw new Error(this.text('ui_18'));
        this.loadStage = 'FILE-FETCH';
        this.request = new AbortController();
        const request = this.request;
        timer = setTimeout(() => request.abort(),60000);
        const response = await fetch(url.href,{signal:request.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error([401,403].includes(response.status) ? this.text('ui_19') : this.text('ui_http', {status:response.status}));
        this.loadStage = 'FILE-BODY';
        const buffer = await response.arrayBuffer(); clearTimeout(timer);
        if (!alive()) return;
        this.loadStage = 'FILE-TYPE';
        const header = new TextDecoder('latin1').decode(buffer.slice(0,1024));
        if (header.includes('%PDF-')) {
          await this.openPdf(buffer,alive);
        } else {
        this.loadStage = 'EPUB-LIB';
        await loadDependencies(this.text.bind(this)); if (!alive()) return;
        this.setFormat(false);
        const signature = new Uint8Array(buffer,0,Math.min(2,buffer.byteLength));
        if (signature[0] !== 0x50 || signature[1] !== 0x4b) throw new Error(this.text('ui_20'));
        this.loadStage = 'EPUB-OPEN';
        const book = window.ePub(); this.book = book;
        await limitTime(book.open(buffer,'binary'),30000,this.text('ui_21'));
        if (!alive()) return;
        this.storageKey = 'member_epub_v4:' + this.dataset.customer + ':' + this.dataset.product + ':' + this.dataset.source;
        const metadata = book.packaging.metadata;
        this.rtl = metadata.direction === 'rtl';
        this.fixed = metadata.layout === 'pre-paginated';
        this.ui['font-controls'].hidden = false;
        this.ui.workspace.hidden = false;
        // First-version typography controls; always show a single page.
        this.rendition = book.renderTo(this.ui.viewport,{
          width:'100%',height:'100%',flow:'paginated',spread:'none',
          allowScriptedContent:false,allowPopups:false
        });
        this.rendition.on('relocated',value => {if(alive()) this.relocated(value);});
        this.rendition.on('keydown',event => this.key(event));
        this.rendition.hooks.content.register(function (contents) {
        contents.document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, true);
        });
        this.restoreSettings();
        this.applyTheme();
        this.rendition.themes.fontSize(this.font + 'px');
        this.updateFont();
        const navigation = await limitTime(book.loaded.navigation,15000,this.text('ui_22'));
        if (!alive()) return;
        this.buildToc(navigation.toc || []);
        const saved = this.readPosition();
        try {
          await limitTime(this.rendition.display(saved || undefined),20000,this.text('ui_23'));
        } catch(error) {
          if (!saved || !alive()) throw error;
          await limitTime(this.rendition.display(),20000,this.text('ui_23'));
        }
        if (!alive()) return;
        }
        if (!alive()) return;
        this.shell.classList.add('er-expanded');
        this.ready = true; this.ui.controls.disabled = false; this.ui.intro.hidden = true;
        this.message(this.text(this.isPdf ? 'pdf_drag_hint' : 'ui_24'));
        this.updateButtons();
        this.size = [this.ui.viewport.clientWidth,this.ui.viewport.clientHeight];
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleResize());
          this.observer.observe(this.ui.viewport);
        }
      } catch(error) {
        if (!alive()) return;
        this.destroyBook(); this.ui.workspace.hidden = false; this.ui.intro.hidden = false;
        this.ui.start.textContent = this.text('ui_25');
        const stage = this.loadStage || 'READER';
        const detail = String(error && error.message || error).replace(/https?:\/\/[^\s"'<>]+/g,'[URL]').slice(0,220);
        const key = error.name === 'AbortError' ? 'ui_26' : stage === 'PDF-LIB' ? 'pdf_library_error' : stage.startsWith('PDF-') ? 'pdf_open_error' : 'ui_27';
        this.message(this.text(key) + ' [' + stage + '] ' + detail,true);
        console.error('[Member reader][' + stage + ']', error);
      } finally {
        clearTimeout(timer);
        if (this.token === token) {this.loading = false;this.ui.start.disabled = false;this.shell.classList.remove('er-loading');this.shell.setAttribute('aria-busy','false');}
      }
    }
    setFormat(pdf) {
      this.isPdf = pdf;
      if(this.pdfWidth) this.pdfWidth.hidden = !pdf;
      this.shell.classList.toggle('er-pdf',pdf);
      this.ui.toc.parentElement.querySelector('span').textContent = this.text(pdf ? 'pdf_page_label' : 'ui_55');
      this.ui.toc.setAttribute('aria-label',this.text(pdf ? 'pdf_select_page' : 'ui_28'));
      this.ui['font-down'].textContent = pdf ? '−' : 'A−';
      this.ui['font-up'].textContent = pdf ? '＋' : 'A＋';
      this.ui['font-down'].setAttribute('aria-label',this.text(pdf ? 'pdf_zoom_out' : 'ui_41'));
      this.ui['font-up'].setAttribute('aria-label',this.text(pdf ? 'pdf_zoom_in' : 'ui_42'));
      this.ui.reset.textContent = this.text(pdf ? 'pdf_fit' : 'ui_56');
    }
    async openPdf(buffer,alive) {
      this.loadStage = 'PDF-LIB';
      const lib = await loadPdfDependencies(this.text.bind(this)); if (!alive()) return;
      this.setFormat(true); this.rtl = false; this.zoom = 1; this.pdfFit = 'width';
      this.storageKey = 'member_pdf_v1:' + this.dataset.customer + ':' + this.dataset.product + ':' + this.dataset.source;
      this.loadStage = 'PDF-OPEN';
      this.pdfTask = lib.getDocument({data:new Uint8Array(buffer),isEvalSupported:false,
        cMapUrl:pdfBase+'cmaps/',cMapPacked:true,standardFontDataUrl:pdfBase+'standard_fonts/'});
      const pdf = await limitTime(this.pdfTask.promise,45000,this.text('pdf_parse'));
      if (!alive()) return;
      this.pdf = pdf;
      let page = 1;
      if (this.remember) try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if (saved) {
          page = Number(saved.page) || 1;
          this.pdfFit = saved.fit === 'page' ? 'page' : 'width';
          this.zoom = saved.fit ? Math.max(.5,Math.min(3,Number(saved.zoom)||1)) : 1;
          if (['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
        }
      } catch (_) {}
      this.ui.toc.replaceChildren(); this.ui.toc.disabled = false;
      const options = document.createDocumentFragment();
      for(let n=1;n<=this.pdf.numPages;n++) options.appendChild(new Option(this.text('pdf_page',{number:n}),String(n)));
      this.ui.toc.appendChild(options);
      this.rendition = {
        display:page => this.renderPdf(Number(page)),
        prev:() => this.renderPdf(this.pdfPage-1), next:() => this.renderPdf(this.pdfPage+1),
        resize:() => {this.renderPdf(this.pdfPage,{preserve:true}).catch(error => this.message(this.text('pdf_render_error'),true));},
        destroy:() => {}
      };
      this.ui.workspace.hidden = false;
      this.ui.intro.hidden = true;
      this.shell.classList.add('er-expanded');
      this.applyTheme(); this.updateFont();
      this.loadStage = 'PDF-RENDER';
      // Wait until the expanded reading area has its final layout before the first page.
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (!alive()) return;
      await this.renderPdf(page);
    }
    fitPdf(mode) {
      if(!this.isPdf || !this.ready || this.navigating) return;
      this.pdfFit = mode; this.zoom = 1; this.updateFont();
      this.navigate(() => this.renderPdf(this.pdfPage,{preserve:true}));
    }
    async renderPdf(number,options = {}) {
      const doc = this.pdf, token = this.token;
      const serial = this.pdfSerial = (this.pdfSerial || 0)+1;
      if (!doc) return;
      const current = () => this.isConnected && this.token === token && this.pdf === doc && this.pdfSerial === serial;
      if (this.pdfRender) {this.pdfRender.cancel(); this.pdfRender = null;}
      const pageNumber = Math.max(1,Math.min(doc.numPages,Math.trunc(number)||1));
      const page = await doc.getPage(pageNumber);
      if (!current()) return;
      const base = page.getViewport({scale:1});
      const box = this.ui.viewport;
      const previous = box.querySelector('canvas');
      const canvas = document.createElement('canvas');
      // Insert the first canvas BEFORE measuring: theme div:empty rules can
      // otherwise hide this host forever, even after waiting for more frames.
      if (!previous) {
        box.replaceChildren(canvas);
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!current()) return;
      }
      // A newly expanded or fullscreen container can still have zero dimensions.
      // Wait for usable layout instead of drawing a tiny page or failing immediately.
      const layoutDeadline = Date.now() + 3000;
      while(box.clientWidth < 2 || box.clientHeight < 2) {
        if (!current()) return;
        if (Date.now() >= layoutDeadline) {
          throw new Error(this.text('pdf_render_error') + ' [PDF-LAYOUT ' + box.clientWidth + 'x' + box.clientHeight + ']');
        }
        await new Promise(resolve => setTimeout(resolve,50));
      }
      if (!current()) return;
      const fitWidth = Math.max(1,box.clientWidth-16)/base.width;
      const fitPage = Math.min(fitWidth,Math.max(1,box.clientHeight-16)/base.height);
      const fit = this.pdfFit === 'page' ? fitPage : fitWidth;
      const viewport = page.getViewport({scale:fit*this.zoom});
      // Limit pixel allocation on mobile and very large pages.
      const ratio = Math.min(window.devicePixelRatio||1,2,Math.sqrt(8000000/(viewport.width*viewport.height)),8192/Math.max(viewport.width,viewport.height));
      canvas.width = Math.max(1,Math.floor(viewport.width*ratio));
      canvas.height = Math.max(1,Math.floor(viewport.height*ratio));
      canvas.style.width = viewport.width+'px'; canvas.style.height = viewport.height+'px';
      canvas.setAttribute('role','img'); canvas.setAttribute('aria-label','PDF '+this.text('pdf_page',{number:pageNumber}));
      const preserve = options.preserve && this.pdfPage === pageNumber && previous;
      // Keep the viewed point at the center while changing zoom or viewport size.
      const oldWidth = previous ? parseFloat(previous.style.width) : 1;
      const oldHeight = previous ? parseFloat(previous.style.height) : 1;
      const oldLeft = previous ? previous.offsetLeft : 8;
      const centerX = (box.scrollLeft + box.clientWidth/2 - oldLeft)/oldWidth;
      const centerY = (box.scrollTop + box.clientHeight/2 - 8)/oldHeight;
      box.replaceChildren(canvas);
      box.scrollLeft = preserve ? Math.max(0,centerX*viewport.width + canvas.offsetLeft - box.clientWidth/2) : Math.max(0,(box.scrollWidth-box.clientWidth)/2);
      box.scrollTop = preserve ? Math.max(0,centerY*viewport.height + 8 - box.clientHeight/2) : 0;
      await new Promise(resolve => requestAnimationFrame(resolve));
      if (!current()) return;
      const context = canvas.getContext('2d');
      if(!context) throw new Error(this.text('pdf_render_error') + ' [PDF-CANVAS]');
      const task = page.render({canvasContext:context,viewport,transform:ratio===1?null:[ratio,0,0,ratio,0,0]});
      this.pdfRender = task;
      try {await task.promise;} catch(error) {if(error.name==='RenderingCancelledException') return; throw error;}
      if (!current()) return;
      this.pdfRender = null;
      this.pdfPage = pageNumber;
      this.position = {atStart:pageNumber===1,atEnd:pageNumber===doc.numPages};
      this.ui.location.textContent = this.text('pdf_location',{current:pageNumber,total:doc.numPages});
      this.ui.toc.value = String(pageNumber);
      this.savePosition(); this.updateButtons();
    }
    buildToc(items) {
      this.ui.toc.replaceChildren();
      this.ui.toc.add(new Option(items.length ? this.text('ui_28') : this.text('ui_29'),''));
      const append = (entries,depth) => entries.forEach(item => {
        if (item.href) this.ui.toc.add(new Option('　'.repeat(Math.min(depth,5)) + String(item.label || this.text('ui_30')).trim(),item.href));
        if (item.subitems) append(item.subitems,depth+1);
      });
      append(items,0); this.ui.toc.disabled = this.ui.toc.options.length < 2;
    }
    relocated(value) {
      if (!this.isConnected || !this.book) return;
      this.position = value;
      if (value.start) {
        this.ui.location.textContent = this.text('ui_location', {current:Number(value.start.index)+1, total:Math.max(1,this.book.spine.spineItems.length - 1)});
        const href = String(value.start.href || '').split('#')[0];
        const match = Array.from(this.ui.toc.options).find(option => option.value && option.value.split('#')[0] === href);
        this.ui.toc.value = match ? match.value : '';
        this.savePosition();
      }
      this.updateButtons();
    }
    updateButtons() {
      const busy = !this.ready || this.navigating;
      const prev = busy || Boolean(this.position && this.position.atStart);
      const next = busy || Boolean(this.position && this.position.atEnd);
      this.ui.prev.disabled = prev; this.ui.next.disabled = next;
      this.ui.left.disabled = this.rtl ? next : prev;
      this.ui.right.disabled = this.rtl ? prev : next;
      this.ui.left.setAttribute('aria-label',this.rtl ? this.text('ui_31') : this.text('ui_32'));
      this.ui.right.setAttribute('aria-label',this.rtl ? this.text('ui_32') : this.text('ui_31'));
    }
    async navigate(action) {
      if (!this.ready || this.navigating) return;
      this.navigating = true; this.ui.controls.disabled = true;
      this.ui.viewport.setAttribute('aria-busy','true'); this.updateButtons();
      try {await action();}
      catch(_) {if(this.isConnected) this.message(this.text('ui_33'),true);}
      finally {
        this.navigating = false;
        if(this.isConnected) {
          this.ui.controls.disabled = false; this.ui.viewport.setAttribute('aria-busy','false'); this.updateButtons();
        }
      }
    }
    move(direction) {
      if(!this.rendition) return;
      if(this.position && (direction === 'prev' ? this.position.atStart : this.position.atEnd)) return;
      this.navigate(() => this.rendition[direction]());
    }
    key(event) {
      if(event.key === 'Escape' && this.full) {
        event.preventDefault(); this.exitFullscreen(); return;
      }
      if (event.key === 'Tab' && this.full) {
        // Keep keyboard navigation in the full-screen reader, including CSS fallback.
        const items = Array.from(this.shell.querySelectorAll('button,select,[tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const index = items.indexOf(document.activeElement);
        if(items.length && (index === -1 || (event.shiftKey ? index === 0 : index === items.length-1))) {
          event.preventDefault(); items[event.shiftKey ? items.length-1 : 0].focus();
        }
        return;
      }
      if(event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      if(event.target.closest && event.target.closest('input,textarea,select,button,a,[contenteditable]')) return;
      if(!this.ready || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move((this.rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight') ? 'next' : 'prev');
    }
    changeFont(delta) {
      if(!this.ready || this.navigating) return;
      if(this.isPdf) {this.zoom = Math.max(.5,Math.min(3,Math.round((this.zoom + (delta>0 ? .25 : -.25))*100)/100));this.updateFont();this.navigate(() => this.renderPdf(this.pdfPage,{preserve:true}));return;}
      this.font = Math.max(14,Math.min(32,(this.font || Number(this.dataset.font) || 18)+delta));
      this.rendition.themes.fontSize(this.font + 'px'); this.updateFont(); this.savePosition();
    }
    resetFont() {
      if(!this.ready || this.navigating) return;
      if(this.isPdf) {this.fitPdf('page');return;}
      this.font = Number(this.dataset.font) || 18;
      this.rendition.themes.fontSize(this.font + 'px');
      this.updateFont(); this.savePosition();
    }
    updateFont() {
      const zoomed = Boolean(this.isPdf && this.zoom > 1);
      this.shell.classList.toggle('er-pdf-zoomed',zoomed);
      if(this.pdfWidth) this.pdfWidth.hidden = !this.isPdf;
      if(this.isPdf) {
        this.ui['font-value'].textContent = Math.round(this.zoom*100)+'%';
        this.ui['font-down'].disabled = this.zoom<=.5;
        this.ui['font-up'].disabled = this.zoom>=3;
        this.ui.reset.disabled = this.pdfFit==='page' && this.zoom===1;
        if(this.pdfWidth) this.pdfWidth.disabled = this.pdfFit==='width' && this.zoom===1;
        return;
      }
      this.shell.style.setProperty('--er-hint-font',this.font + 'px');
      this.ui['font-value'].textContent = this.font + 'px';
      this.ui['font-down'].disabled = this.font <= 14;
      this.ui['font-up'].disabled = this.font >= 32;
      this.ui.reset.disabled = this.font === (Number(this.dataset.font) || 18);
    }
    applyTheme() {
      if(!this.rendition) return;
      const palettes = {
        light:{background:'#ffffff',text:'#202934',link:'#1659a5'},
        sepia:{background:'#f6efdf',text:'#433a2e',link:'#72501e'},
        dark:{background:'#20252b',text:'#e3e8ee',link:'#96c8ff'}
      };
      const palette = palettes[this.ui.theme.value] || palettes.light;
      this.ui.viewport.style.backgroundColor = palette.background;
      this.ui.viewport.parentElement.style.backgroundColor = palette.background;
      this.shell.style.backgroundColor = palette.background;
      if(this.isPdf) return;
      this.rendition.themes.default({
        'html':{'background':palette.background+' !important'},
        'body':{'background':palette.background+' !important','color':palette.text+' !important','line-height':'1.8 !important','overflow-wrap':'break-word'},
        'p, div, span, li, h1, h2, h3, h4, h5, h6, blockquote':{'color':palette.text+' !important'},
        'a':{'color':palette.link+' !important'},
        'img, svg, video':{'max-width':'100% !important','max-height':'100% !important','object-fit':'contain'}
      });
    }
    restoreSettings() {
      if(!this.remember) return;
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if(saved && Number.isFinite(saved.font)) this.font = Math.max(14,Math.min(32,saved.font));
        if(saved && ['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
      } catch(_) {}
    }
    showFullscreenHint() {
      clearTimeout(this.hintTimer);
      this.shell.classList.add('er-show-zones');
      if(this.isPdf) {
        this.ui['full-hint'].replaceChildren();
        ['pdf_hint_title','pdf_hint_fit','pdf_hint_pages'].forEach(key => {
          const line = document.createElement('span');line.textContent = this.text(key);
          this.ui['full-hint'].appendChild(line);
        });
      }
      else {this.ui['full-hint'].replaceChildren(document.createTextNode(this.text('ui_62')),document.createElement('br'),document.createElement('br'),document.createTextNode(this.text('ui_63')));}
      this.ui['full-hint'].hidden = false;
      this.hintTimer = setTimeout(() => {
        this.ui['full-hint'].hidden = true;
        this.shell.classList.remove('er-show-zones');
      },3000);
    }
    async toggleFullscreen() {
      if(this.full) {await this.exitFullscreen();return;}
      if(!this.ready || this.entering || fullscreenOwner) return;
      this.entering = true; fullscreenOwner = this;
      // Capture the actual book viewport BEFORE portaling or hiding scrollbars.
      this.shell.style.setProperty('--er-reading-width',this.isPdf ? '100%' : this.ui.viewport.clientWidth + 'px');
      this.returnFocus = document.activeElement;
      this.placeholder = document.createComment('EPUB fullscreen return position');
      this.shell.before(this.placeholder);
      // Portal only the shell: custom element stays mounted and keeps book state.
      document.body.appendChild(this.shell);
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.full = true; this.native = false;
      this.shell.classList.add('er-full');
      this.ui.center.hidden = this.isPdf; this.ui['fs-hint'].hidden = this.isPdf;
      this.ui.fullscreen.textContent = this.text('ui_34');
      this.setMenu(false); (this.isPdf ? this.ui.viewport : this.ui.center).focus({preventScroll:true});
      const request = this.shell.requestFullscreen || this.shell.webkitRequestFullscreen;
      try {
        if(request) {
          await request.call(this.shell);
          this.native = (document.fullscreenElement || document.webkitFullscreenElement) === this.shell;
        }
      } catch(_) {
        // iPhone / restricted iframe: CSS viewport fullscreen is the fallback.
      } finally {
        this.entering = false;
        if(!this.isConnected) this.restoreFullscreen();
        else if(this.full) {this.scheduleResize();this.showFullscreenHint();}
      }
    }
    setMenu(open) {
      this.menuOpen = Boolean(open);
      if(this.pdfTopToggle) {
        this.pdfTopToggle.textContent = this.text(this.menuOpen ? 'pdf_hide_top' : 'pdf_show_top');
        this.pdfTopToggle.setAttribute('aria-expanded',String(this.menuOpen));
      }
      this.shell.classList.toggle('er-menu-open',this.menuOpen);
      this.ui.center.setAttribute('aria-expanded',String(this.menuOpen));
      this.ui.center.setAttribute('aria-label',this.menuOpen ? this.text('ui_35') : this.text('ui_36'));
      for(const key of ['top','bottom']) {
        this.ui[key].inert = Boolean(this.full && !this.menuOpen && !(this.isPdf && key === 'bottom'));
      }
    }
    fullscreenChanged() {
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {this.native = true;return;}
      if(this.full && this.native) this.restoreFullscreen();
    }
    async exitFullscreen() {
      if(!this.full) return;
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        try {if(exit) await exit.call(document);} catch(_) {return;}
      }
      this.restoreFullscreen();
    }
    restoreFullscreen() {
      if(!this.full) return;
      clearTimeout(this.hintTimer); this.ui['full-hint'].hidden = true;
      this.full = false; this.native = false;
      this.shell.style.removeProperty('--er-reading-width');
      this.shell.classList.remove('er-full','er-menu-open','er-show-zones');
      this.ui.center.hidden = true; this.ui['fs-hint'].hidden = true;
      this.ui.fullscreen.textContent = this.text('ui_37');
      this.setMenu(false);
      if(this.placeholder && this.placeholder.parentNode) this.placeholder.replaceWith(this.shell);
      else this.appendChild(this.shell);
      document.body.style.overflow = this.oldOverflow || '';
      if(fullscreenOwner === this) fullscreenOwner = null;
      if(this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({preventScroll:true});
      this.scheduleResize();
    }
    scheduleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if(!this.ready || !this.rendition || !this.isConnected) return;
        const width = this.ui.viewport.clientWidth, height = this.ui.viewport.clientHeight;
        if(width < 1 || height < 1 || (this.size && this.size[0] === width && this.size[1] === height)) return;
        this.size = [width,height]; this.rendition.resize(width,height);
      },120);
    }
    readPosition() {
      if(!this.remember) return null;
      try {const value = JSON.parse(localStorage.getItem(this.storageKey));return value && typeof value.cfi === 'string' ? value.cfi : null;} catch(_) {return null;}
    }
    savePosition() {
      if(this.isPdf) {
        if(this.remember && this.storageKey && this.pdfPage) try {
          localStorage.setItem(this.storageKey,JSON.stringify({page:this.pdfPage,zoom:this.zoom,fit:this.pdfFit,theme:this.ui.theme.value}));
        } catch (_) {}
        return;
      }
      if(!this.remember || !this.storageKey || !this.position || !this.position.start) return;
      try {localStorage.setItem(this.storageKey,JSON.stringify({cfi:this.position.start.cfi,font:this.font,theme:this.ui.theme.value}));} catch(_) {}
    }
    destroyBook() {
      this.pdfSerial = (this.pdfSerial || 0)+1;
      if(this.pdfRender) {this.pdfRender.cancel();this.pdfRender=null;}
      if(this.pdfTask) {try {Promise.resolve(this.pdfTask.destroy()).catch(() => {});} catch (_) {} this.pdfTask=null;}
      this.pdf=null; this.pdfPage=null; this.zoom=1; this.pdfFit='width'; this.pdfDrag=null;
      if(this.ui) this.ui.viewport.classList.remove('er-dragging');
      if(this.ui) this.setFormat(false);
      clearTimeout(this.hintTimer);
      this.ready = false; this.position = null; this.font = Number(this.dataset.font) || 18;
      if(this.observer) this.observer.disconnect();
      clearTimeout(this.resizeTimer);
      try {if(this.rendition) this.rendition.destroy();} catch(_) {}
      try {if(this.book) this.book.destroy();} catch(_) {}
      this.rendition = null; this.book = null;
      if(this.ui) {this.ui.viewport.replaceChildren();this.updateFont();}
    }
    disconnectedCallback() {
      this.savePosition(); this.token = null;
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      if(this.request) this.request.abort();
      if(this.ui) {this.restoreFullscreen(); this.destroyBook();}
      this.loading = false; this.navigating = false; this.initialized = false;
    }
  }
  customElements.define('member-product-epub-reader',EpubReader);
})();

(() => {
  if(customElements.get('member-product-bunny-playlist')) return;
  class BunnyPlaylist extends HTMLElement {
    text(key, values = {}) {
      if (!this.uiStrings) {
        try { this.uiStrings = JSON.parse(this.dataset.i18n || '{}'); }
        catch (_) { this.uiStrings = {}; }
      }
      const value = String(this.uiStrings[key] ?? '');
      return value.replace(/\[(\w+)\]/g, (match, name) =>
        Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
    }

    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if(!this.isConnected) return;
      const frame = this.querySelector('[data-bunny-frame]');
      const status = this.querySelector('[data-media-status]');
      const buttons = [...this.querySelectorAll('[data-media-path]')];
      const valid = buttons.filter(button => {
        const path = button.dataset.mediaPath.trim();
        const ok = /^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden = !ok;
        if(ok) button.dataset.mediaPath = path;
        return ok;
      });
      if(valid.length !== buttons.length) {
        status.hidden = false;
        status.textContent = this.text('ui_38');
      }
      frame.hidden = !valid.length;
      const nav = this.querySelector('.mm-playlist');
      nav.hidden = valid.length === 0;
      this.querySelector('.mm-media-layout').classList.toggle('mm-has-list',valid.length > 0);
      const select = button => {
        if(button.getAttribute('aria-pressed') === 'true') return;
        frame.src = 'https://player.mediadelivery.net/embed/' + button.dataset.mediaPath + '?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
        frame.title = this.text('ui_player_title', {title:button.textContent.trim()});
        valid.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      };
      this.events = new AbortController();
      valid.forEach((button,index) => {
        button.textContent = this.text('ui_episode', {number:index + 1});
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',() => select(button),{signal:this.events.signal});
      });
      const syncPlaylistHeight = () => {
        const height = frame.getBoundingClientRect().height;
        if (height > 0) this.style.setProperty('--mm-video-height', height + 'px');
      };
      if (typeof ResizeObserver !== 'undefined') {
        this.sizeObserver = new ResizeObserver(syncPlaylistHeight);
        this.sizeObserver.observe(frame);
      }
      window.addEventListener('resize', syncPlaylistHeight, {signal:this.events.signal});
      frame.addEventListener('load', syncPlaylistHeight, {signal:this.events.signal});
      syncPlaylistHeight();
      if(valid.length) select(valid[0]);
    }
    disconnectedCallback() {
      if(this.sizeObserver) this.sizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      this.initialized = false;
    }
  }
  customElements.define('member-product-bunny-playlist',BunnyPlaylist);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-video-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('member-title-video-player')) return;
  class MemberTitleVideoPlayer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animationFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      const frame = this.querySelector('[data-video-frame]');
      const status = this.querySelector('[data-video-status]');
      const nav = this.querySelector('.mvp-playlist');
      const layout = this.querySelector('.mvp-layout');
      const buttons = [...this.querySelectorAll('[data-media-path]')];
      const valid = buttons.filter(button => {
        const path = button.dataset.mediaPath.trim();
        const ok = /^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden = !ok;
        if (ok) button.dataset.mediaPath = path;
        return ok;
      });
      status.hidden = valid.length === buttons.length;
      status.textContent = valid.length === buttons.length ? '' : '部分影音資料格式不正確，請聯絡網站管理員。';
      frame.hidden = valid.length === 0;
      // 單集仍載入第一集，但不顯示清單，也不保留清單欄位空間。
      nav.hidden = valid.length <= 1;
      layout.classList.toggle('mvp-has-list', valid.length > 1);
      this.events = new AbortController();
      const select = button => {
        if (button.getAttribute('aria-pressed') === 'true') return;
        frame.src = 'https://player.mediadelivery.net/embed/' + button.dataset.mediaPath + '?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
        frame.title = '影音播放器：' + button.textContent.trim();
        valid.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      valid.forEach((button, index) => {
        button.textContent = '第 ' + (index + 1) + ' 集';
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => select(button), {signal:this.events.signal});
      });
      const syncHeight = () => {
        const height = frame.getBoundingClientRect().height;
        if (height > 0) this.style.setProperty('--mvp-video-height', height + 'px');
      };
      if (typeof ResizeObserver !== 'undefined') {
        this.sizeObserver = new ResizeObserver(syncHeight);
        this.sizeObserver.observe(frame);
      }
      window.addEventListener('resize', syncHeight, {signal:this.events.signal});
      frame.addEventListener('load', syncHeight, {signal:this.events.signal});
      if (valid.length) select(valid[0]);
      syncHeight();
    }
    disconnectedCallback() {
      if (this.sizeObserver) this.sizeObserver.disconnect();
      cancelAnimationFrame(this.animationFrame);
      if (this.events) this.events.abort();
      this.initialized = false;
    }
  }
  customElements.define('member-title-video-player', MemberTitleVideoPlayer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-video"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('member-epub-reader-v4')) return;
  let dependencies;
  let fullscreenOwner = null;
  const limitTime = (promise, ms, message) => {
    let timer;
    return Promise.race([promise,new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    })]).finally(() => clearTimeout(timer));
  };
  function script(src) {
    return new Promise((resolve,reject) => {
      const element = document.createElement('script');
      const timer = setTimeout(() => {
        element.remove(); reject(new Error('閱讀器元件載入逾時，請重新整理後再試。'));
      },25000);
      element.src = src; element.async = true;
      element.onload = () => {clearTimeout(timer);resolve();};
      element.onerror = () => {clearTimeout(timer);element.remove();reject(new Error('無法載入閱讀器元件，請檢查網路。'));};
      document.head.appendChild(element);
    });
  }
  function loadDependencies() {
    if (!dependencies) dependencies = (async () => {
      if (!window.JSZip) await script('https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js');
      if (!window.ePub) await script('https://cdn.jsdelivr.net/npm/epubjs@0.3.93/dist/epub.min.js');
      if (!window.ePub || !window.JSZip) throw new Error('閱讀器元件未正常啟動。');
    })().catch(error => {dependencies = null;throw error;});
    return dependencies;
  }
  class EpubReader extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      this.events = new AbortController();
      this.shell = this.querySelector('.er-shell');
      this.ui = {};
      ['intro','start','status','workspace','controls','toc','font-controls','font-down','font-up','font-value','reset','fullscreen','viewport','left','right','center','prev','next','location','top','bottom','fs-hint','full-hint','theme'].forEach(key => {
        this.ui[key] = this.shell.querySelector('[data-' + key + ']');
      });
      this.remember = this.dataset.remember === 'true';
      this.font = Number(this.dataset.font) || 18;
      this.ready = false;
      const on = (el,name,fn) => el.addEventListener(name,fn,{signal:this.events.signal});
      on(this.ui.start,'click',() => this.start());
      on(this.ui.prev,'click',() => this.move('prev'));
      on(this.ui.next,'click',() => this.move('next'));
      on(this.ui.left,'click',() => this.move(this.rtl ? 'next' : 'prev'));
      on(this.ui.right,'click',() => this.move(this.rtl ? 'prev' : 'next'));
      on(this.ui.toc,'change',() => {if(this.ui.toc.value) this.navigate(() => this.rendition.display(this.ui.toc.value));});
      on(this.ui['font-down'],'click',() => this.changeFont(-2));
      on(this.ui['font-up'],'click',() => this.changeFont(2));
      on(this.ui.reset,'click',() => this.resetFont());
      on(this.ui.theme,'change',() => {this.applyTheme();this.savePosition();});
      on(this.ui.fullscreen,'click',() => this.toggleFullscreen());
      on(this.ui.center,'click',() => this.setMenu(!this.menuOpen));
      on(this.shell,'keydown',event => this.key(event));
      on(document,'fullscreenchange',() => this.fullscreenChanged());
      on(document,'webkitfullscreenchange',() => this.fullscreenChanged());
      this.bookIndex = '1';
      this.shell.querySelectorAll('[data-book-source]').forEach(button => {
        let name = '';
        try {
          name = new URL(button.dataset.bookSource, location.href).pathname.split('/').pop();
          try {name = decodeURIComponent(name);} catch (_) {}
        } catch (_) {}
        name = name.replace(/\.[^.]+$/, '') || '未命名電子書';
        button.textContent = name;
        button.title = name;
      });
      on(this.shell,'click',event => {
        const button = event.target.closest('[data-book-source]');
        if (button) this.selectBook(button);
      });
      this.updateFont();
    }
    async selectBook(button) {
      if (this.navigating || this.switching || this.entering) return;
      const source = button.dataset.bookSource;
      if (source === this.dataset.source && (this.ready || this.loading)) return;
      this.switching = true;
      try {
        this.savePosition();
        if (this.full) await this.exitFullscreen();
        if (this.full || !this.isConnected) return;
        this.token = null;
        if (this.request) this.request.abort();
        this.destroyBook();
        this.storageKey = null; this.size = null;
        this.loading = false; this.navigating = false;
        this.dataset.source = source;
        this.bookIndex = button.dataset.bookIndex;
        this.ui.theme.value = 'light';
        this.ui.workspace.hidden = false;
        this.ui.intro.hidden = false;
        this.ui.start.disabled = false;
        this.ui.start.textContent = '開始閱讀';
        this.ui.controls.disabled = true;
        this.ui.toc.replaceChildren(new Option('載入目錄',''));
        this.ui.location.textContent = '位於章節索引 —';
        this.updateButtons();
        this.shell.querySelectorAll('[data-book-source]').forEach(el => {
          el.setAttribute('aria-pressed',String(el.dataset.bookIndex === this.bookIndex));
        });
        this.start();
      } finally {this.switching = false;}
    }
    message(text,error=false) {
      this.ui.status.textContent = text;
      this.ui.status.dataset.error = String(error);
    }
    async start() {
      if (this.loading || this.ready) return;
      this.loading = true; this.ui.start.disabled = true;
      this.shell.classList.add('er-loading');
      this.ui.start.textContent = '正在載入…';
      this.shell.setAttribute('aria-busy','true');
      const token = {}; this.token = token;
      const alive = () => this.isConnected && this.token === token;
      let timer;
      this.message('正在載入電子書，較大的檔案需要稍候。');
      try {
        const url = new URL(this.dataset.source,location.href);
        if (!['https:','http:'].includes(url.protocol) || (location.protocol === 'https:' && url.protocol !== 'https:')) throw new Error('請填入有效的 HTTPS EPUB 檔案網址。');
        await loadDependencies(); if (!alive()) return;
        this.request = new AbortController();
        const request = this.request;
        timer = setTimeout(() => request.abort(),60000);
        const response = await fetch(url.href,{signal:request.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error([401,403].includes(response.status) ? '沒有讀取權限，請確認登入狀態。' : '檔案載入失敗，HTTP ' + response.status);
        const buffer = await response.arrayBuffer(); clearTimeout(timer);
        if (!alive()) return;
        const signature = new Uint8Array(buffer,0,Math.min(2,buffer.byteLength));
        if (signature[0] !== 0x50 || signature[1] !== 0x4b) throw new Error('網址未回傳 EPUB 檔案，請勿使用商品頁或下載頁網址。');
        const book = window.ePub(); this.book = book;
        await limitTime(book.open(buffer,'binary'),30000,'電子書解析逾時，請確認檔案格式。');
        if (!alive()) return;
        this.storageKey = 'member_epub_v4:' + this.dataset.customer + ':' + this.dataset.product + ':' + this.dataset.source;
        const metadata = book.packaging.metadata;
        this.rtl = metadata.direction === 'rtl';
        this.fixed = metadata.layout === 'pre-paginated';
        this.ui['font-controls'].hidden = false;
        this.ui.workspace.hidden = false;
        // First-version typography controls; always show a single page.
        this.rendition = book.renderTo(this.ui.viewport,{
          width:'100%',height:'100%',flow:'paginated',spread:'none',
          allowScriptedContent:false,allowPopups:false
        });
        this.rendition.on('relocated',value => {if(alive()) this.relocated(value);});
        this.rendition.on('keydown',event => this.key(event));
        this.rendition.hooks.content.register(function (contents) {
        contents.document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, true);
        });
        this.restoreSettings();
        this.applyTheme();
        this.rendition.themes.fontSize(this.font + 'px');
        this.updateFont();
        const navigation = await limitTime(book.loaded.navigation,15000,'無法讀取目錄。');
        if (!alive()) return;
        this.buildToc(navigation.toc || []);
        const saved = this.readPosition();
        try {
          await limitTime(this.rendition.display(saved || undefined),20000,'無法顯示書籍。');
        } catch(error) {
          if (!saved || !alive()) throw error;
          await limitTime(this.rendition.display(),20000,'無法顯示書籍。');
        }
        if (!alive()) return;
        this.shell.classList.add('er-expanded');
        this.ready = true; this.ui.controls.disabled = false; this.ui.intro.hidden = true;
        this.message('單頁閱讀｜點左右兩側翻頁；全螢幕時點中央開啟選單。');
        this.updateButtons();
        this.size = [this.ui.viewport.clientWidth,this.ui.viewport.clientHeight];
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleResize());
          this.observer.observe(this.ui.viewport);
        }
      } catch(error) {
        if (!alive()) return;
        this.destroyBook(); this.ui.workspace.hidden = false; this.ui.intro.hidden = false;
        this.ui.start.textContent = '重新載入';
        this.message(error.name === 'AbortError' ? '下載逾時，請檢查網路後再試。' : error instanceof TypeError ? '無法讀取 EPUB，請檢查網址、網路與跨網域讀取設定。' : error.message,true);
      } finally {
        clearTimeout(timer);
        if (this.token === token) {this.loading = false;this.ui.start.disabled = false;this.shell.classList.remove('er-loading');this.shell.setAttribute('aria-busy','false');}
      }
    }
    buildToc(items) {
      this.ui.toc.replaceChildren();
      this.ui.toc.add(new Option(items.length ? '選擇章節' : '本書未提供目錄',''));
      const append = (entries,depth) => entries.forEach(item => {
        if (item.href) this.ui.toc.add(new Option('　'.repeat(Math.min(depth,5)) + String(item.label || '未命名章節').trim(),item.href));
        if (item.subitems) append(item.subitems,depth+1);
      });
      append(items,0); this.ui.toc.disabled = this.ui.toc.options.length < 2;
    }
    relocated(value) {
      if (!this.isConnected || !this.book) return;
      this.position = value;
      if (value.start) {
        this.ui.location.textContent = '位於章節索引 ' + (Number(value.start.index)+1) + ' / ' + Math.max(1,this.book.spine.spineItems.length - 1);
        const href = String(value.start.href || '').split('#')[0];
        const match = Array.from(this.ui.toc.options).find(option => option.value && option.value.split('#')[0] === href);
        this.ui.toc.value = match ? match.value : '';
        this.savePosition();
      }
      this.updateButtons();
    }
    updateButtons() {
      const busy = !this.ready || this.navigating;
      const prev = busy || Boolean(this.position && this.position.atStart);
      const next = busy || Boolean(this.position && this.position.atEnd);
      this.ui.prev.disabled = prev; this.ui.next.disabled = next;
      this.ui.left.disabled = this.rtl ? next : prev;
      this.ui.right.disabled = this.rtl ? prev : next;
      this.ui.left.setAttribute('aria-label',this.rtl ? '下一頁' : '上一頁');
      this.ui.right.setAttribute('aria-label',this.rtl ? '上一頁' : '下一頁');
    }
    async navigate(action) {
      if (!this.ready || this.navigating) return;
      this.navigating = true; this.ui.controls.disabled = true;
      this.ui.viewport.setAttribute('aria-busy','true'); this.updateButtons();
      try {await action();}
      catch(_) {if(this.isConnected) this.message('無法切換指定位置，請選擇其他章節或重新整理。',true);}
      finally {
        this.navigating = false;
        if(this.isConnected) {
          this.ui.controls.disabled = false; this.ui.viewport.setAttribute('aria-busy','false'); this.updateButtons();
        }
      }
    }
    move(direction) {
      if(!this.rendition) return;
      if(this.position && (direction === 'prev' ? this.position.atStart : this.position.atEnd)) return;
      this.navigate(() => this.rendition[direction]());
    }
    key(event) {
      if(event.key === 'Escape' && this.full) {
        event.preventDefault(); this.exitFullscreen(); return;
      }
      if (event.key === 'Tab' && this.full) {
        // Keep keyboard navigation in the full-screen reader, including CSS fallback.
        const items = Array.from(this.shell.querySelectorAll('button,select,[tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const index = items.indexOf(document.activeElement);
        if(items.length && (index === -1 || (event.shiftKey ? index === 0 : index === items.length-1))) {
          event.preventDefault(); items[event.shiftKey ? items.length-1 : 0].focus();
        }
        return;
      }
      if(event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      if(event.target.closest && event.target.closest('input,textarea,select,button,a,[contenteditable]')) return;
      if(!this.ready || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move((this.rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight') ? 'next' : 'prev');
    }
    changeFont(delta) {
      if(!this.ready || this.navigating) return;
      this.font = Math.max(14,Math.min(32,(this.font || Number(this.dataset.font) || 18)+delta));
      this.rendition.themes.fontSize(this.font + 'px'); this.updateFont(); this.savePosition();
    }
    resetFont() {
      if(!this.ready || this.navigating) return;
      this.font = Number(this.dataset.font) || 18;
      this.rendition.themes.fontSize(this.font + 'px');
      this.updateFont(); this.savePosition();
    }
    updateFont() {
      this.shell.style.setProperty('--er-hint-font',this.font + 'px');
      this.ui['font-value'].textContent = this.font + 'px';
      this.ui['font-down'].disabled = this.font <= 14;
      this.ui['font-up'].disabled = this.font >= 32;
      this.ui.reset.disabled = this.font === (Number(this.dataset.font) || 18);
    }
    applyTheme() {
      if(!this.rendition) return;
      const palettes = {
        light:{background:'#ffffff',text:'#202934',link:'#1659a5'},
        sepia:{background:'#f6efdf',text:'#433a2e',link:'#72501e'},
        dark:{background:'#20252b',text:'#e3e8ee',link:'#96c8ff'}
      };
      const palette = palettes[this.ui.theme.value] || palettes.light;
      this.ui.viewport.style.backgroundColor = palette.background;
      this.ui.viewport.parentElement.style.backgroundColor = palette.background;
      this.shell.style.backgroundColor = palette.background;
      this.rendition.themes.default({
        'html':{'background':palette.background+' !important'},
        'body':{'background':palette.background+' !important','color':palette.text+' !important','line-height':'1.8 !important','overflow-wrap':'break-word'},
        'p, div, span, li, h1, h2, h3, h4, h5, h6, blockquote':{'color':palette.text+' !important'},
        'a':{'color':palette.link+' !important'},
        'img, svg, video':{'max-width':'100% !important','max-height':'100% !important','object-fit':'contain'}
      });
    }
    restoreSettings() {
      if(!this.remember) return;
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if(saved && Number.isFinite(saved.font)) this.font = Math.max(14,Math.min(32,saved.font));
        if(saved && ['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
      } catch(_) {}
    }
    showFullscreenHint() {
      clearTimeout(this.hintTimer);
      this.shell.classList.add('er-show-zones');
      this.ui['full-hint'].hidden = false;
      this.hintTimer = setTimeout(() => {
        this.ui['full-hint'].hidden = true;
        this.shell.classList.remove('er-show-zones');
      },3000);
    }
    async toggleFullscreen() {
      if(this.full) {await this.exitFullscreen();return;}
      if(!this.ready || this.entering || fullscreenOwner) return;
      this.entering = true; fullscreenOwner = this;
      // Capture the actual book viewport BEFORE portaling or hiding scrollbars.
      this.shell.style.setProperty('--er-reading-width',this.ui.viewport.clientWidth + 'px');
      this.returnFocus = document.activeElement;
      this.placeholder = document.createComment('EPUB fullscreen return position');
      this.shell.before(this.placeholder);
      // Portal only the shell: custom element stays mounted and keeps book state.
      document.body.appendChild(this.shell);
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.full = true; this.native = false;
      this.shell.classList.add('er-full');
      this.ui.center.hidden = false; this.ui['fs-hint'].hidden = false;
      this.ui.fullscreen.textContent = '退出全螢幕';
      this.setMenu(false); this.ui.center.focus({preventScroll:true});
      const request = this.shell.requestFullscreen || this.shell.webkitRequestFullscreen;
      try {
        if(request) {
          await request.call(this.shell);
          this.native = (document.fullscreenElement || document.webkitFullscreenElement) === this.shell;
        }
      } catch(_) {
        // iPhone / restricted iframe: CSS viewport fullscreen is the fallback.
      } finally {
        this.entering = false;
        if(!this.isConnected) this.restoreFullscreen();
        else if(this.full) {this.scheduleResize();this.showFullscreenHint();}
      }
    }
    setMenu(open) {
      this.menuOpen = Boolean(open);
      this.shell.classList.toggle('er-menu-open',this.menuOpen);
      this.ui.center.setAttribute('aria-expanded',String(this.menuOpen));
      this.ui.center.setAttribute('aria-label',this.menuOpen ? '收起閱讀選單' : '顯示閱讀選單');
      for(const key of ['top','bottom']) {
        this.ui[key].inert = Boolean(this.full && !this.menuOpen);
      }
    }
    fullscreenChanged() {
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {this.native = true;return;}
      if(this.full && this.native) this.restoreFullscreen();
    }
    async exitFullscreen() {
      if(!this.full) return;
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        try {if(exit) await exit.call(document);} catch(_) {return;}
      }
      this.restoreFullscreen();
    }
    restoreFullscreen() {
      if(!this.full) return;
      clearTimeout(this.hintTimer); this.ui['full-hint'].hidden = true;
      this.full = false; this.native = false;
      this.shell.style.removeProperty('--er-reading-width');
      this.shell.classList.remove('er-full','er-menu-open','er-show-zones');
      this.ui.center.hidden = true; this.ui['fs-hint'].hidden = true;
      this.ui.fullscreen.textContent = '全螢幕';
      this.setMenu(false);
      if(this.placeholder && this.placeholder.parentNode) this.placeholder.replaceWith(this.shell);
      else this.appendChild(this.shell);
      document.body.style.overflow = this.oldOverflow || '';
      if(fullscreenOwner === this) fullscreenOwner = null;
      if(this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({preventScroll:true});
      this.scheduleResize();
    }
    scheduleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if(!this.ready || !this.rendition || !this.isConnected) return;
        const width = this.ui.viewport.clientWidth, height = this.ui.viewport.clientHeight;
        if(width < 1 || height < 1 || (this.size && this.size[0] === width && this.size[1] === height)) return;
        this.size = [width,height]; this.rendition.resize(width,height);
      },120);
    }
    readPosition() {
      if(!this.remember) return null;
      try {const value = JSON.parse(localStorage.getItem(this.storageKey));return value && typeof value.cfi === 'string' ? value.cfi : null;} catch(_) {return null;}
    }
    savePosition() {
      if(!this.remember || !this.storageKey || !this.position || !this.position.start) return;
      try {localStorage.setItem(this.storageKey,JSON.stringify({cfi:this.position.start.cfi,font:this.font,theme:this.ui.theme.value}));} catch(_) {}
    }
    destroyBook() {
      clearTimeout(this.hintTimer);
      this.ready = false; this.position = null; this.font = Number(this.dataset.font) || 18;
      if(this.observer) this.observer.disconnect();
      clearTimeout(this.resizeTimer);
      try {if(this.rendition) this.rendition.destroy();} catch(_) {}
      try {if(this.book) this.book.destroy();} catch(_) {}
      this.rendition = null; this.book = null;
      if(this.ui) {this.ui.viewport.replaceChildren();this.updateFont();}
    }
    disconnectedCallback() {
      this.savePosition(); this.token = null;
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      if(this.request) this.request.abort();
      if(this.ui) {this.restoreFullscreen(); this.destroyBook();}
      this.loading = false; this.navigating = false; this.initialized = false;
    }
  }
  customElements.define('member-epub-reader-v4',EpubReader);
})();

(() => {
  if(customElements.get('member-bunny-playlist')) return;
  class BunnyPlaylist extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if(!this.isConnected) return;
      const frame = this.querySelector('[data-bunny-frame]');
      const status = this.querySelector('[data-media-status]');
      const buttons = [...this.querySelectorAll('[data-media-path]')];
      const valid = buttons.filter(button => {
        const path = button.dataset.mediaPath.trim();
        const ok = /^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden = !ok;
        if(ok) button.dataset.mediaPath = path;
        return ok;
      });
      if(valid.length !== buttons.length) {
        status.hidden = false;
        status.textContent = '部分影音資料格式不正確，請聯絡網站管理員。';
      }
      frame.hidden = !valid.length;
      const nav = this.querySelector('.mm-playlist');
      nav.hidden = valid.length < 2;
      this.querySelector('.mm-media-layout').classList.toggle('mm-has-list',valid.length > 1);
      const select = button => {
        if(button.getAttribute('aria-pressed') === 'true') return;
        frame.src = 'https://player.mediadelivery.net/embed/' + button.dataset.mediaPath + '?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
        frame.title = '影音播放器：' + button.textContent.trim();
        valid.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      };
      this.events = new AbortController();
      valid.forEach((button,index) => {
        button.textContent = '第 ' + (index + 1) + ' 集';
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',() => select(button),{signal:this.events.signal});
      });
      if(valid.length) select(valid[0]);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      this.initialized = false;
    }
  }
  customElements.define('member-bunny-playlist',BunnyPlaylist);
})();


  } catch(e) { console.error(e); }
})();
})();
